<template>
  <div class="d-inline-flex flex-column align-items-center">
    <subtitle
      class="mb-3"
      v-if="!noSubtitle"
      :value="subtitleValueColors"
    />
    <div class="d-flex flex-row flex-wrap justify-content-center">
      <div
        v-for="(chartView, index) in chartViews"
        :key="index"
        class="polygonal-chart__svg-wrapper"
        :class="chartModifiers"
      >
        <chart-component
          :value="chartView.value"
          :type="chartView.type"
        />
      </div>
    </div>
  </div>
</template>

<script>
import polygonalChartMixin from '@/domain/mixins/installation/engineering/chromatography/polygonalChartMixin';
import ChartComponent from './Chart';
import Subtitle from './Subtitle';

export default {
  components: {
    Subtitle,
    ChartComponent,
  },
  mixins: [polygonalChartMixin],
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.polygonal-chart
  &__svg-wrapper
    display: flex
    &_small
      ::v-deep svg
        max-width: 13.21rem
        width: 100%
        margin: .5rem
    &_multiple
      +media-min-lg()
        margin: 1rem
    &_medium
      ::v-deep svg
        max-width: 24.78rem
        width: 100%
        margin: 1rem
    &_multiple
      +media-min-lg()
        margin: 2rem
</style>
